export const CUSTOMER_ROLE = 0;
export const BILL_TO_ROLE = 1;
export const BROKER_ROLE = 2;
export const VENDOR_ROLE = 3;
export const CHASSISPROVIDER_ROLE = 4;
export const STEAMSHIPLINE_ROLE = 5;

export const APPROVED_ACCOUNTING_STATUS = 1;
